export default __webpack_public_path__ + "static/media/MP.3c63ea9c.svg";